import { useEffect, useState } from 'react'

export type AppTheme = 'dark' | 'light'

export const THEME_STORAGE_KEY = 'saviynt-agent-theme'
export const THEME_CHANGE_EVENT = 'saviynt:theme-change'

export function readTheme(storage: Pick<Storage, 'getItem'> = localStorage): AppTheme {
  return storage.getItem(THEME_STORAGE_KEY) === 'light' ? 'light' : 'dark'
}

export function applyTheme(theme: AppTheme, storage: Pick<Storage, 'setItem'> = localStorage) {
  document.documentElement.dataset.theme = theme
  document.documentElement.style.colorScheme = theme
  storage.setItem(THEME_STORAGE_KEY, theme)
  window.dispatchEvent(new CustomEvent<AppTheme>(THEME_CHANGE_EVENT, { detail: theme }))
}

export function initializeTheme() {
  applyTheme(readTheme())
}

export function useTheme(): [AppTheme, (theme: AppTheme) => void] {
  const [theme, setThemeState] = useState<AppTheme>(() => readTheme())

  useEffect(() => {
    const handleThemeChange = (event: Event) => {
      setThemeState((event as CustomEvent<AppTheme>).detail)
    }
    window.addEventListener(THEME_CHANGE_EVENT, handleThemeChange)
    return () => window.removeEventListener(THEME_CHANGE_EVENT, handleThemeChange)
  }, [])

  return [theme, applyTheme]
}
